var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import TextStatsWidget from './widgets/text-stats-widget.vue';
import StatusWidget from "./widgets/status-widget.vue";
import TwoStatusWidget from "./widgets/two-status-widget.vue";
import ChartWidget from "./widgets/chart-widget.vue";
import HtmlWidget from "./widgets/html-widget.vue";
import { Component } from "vue-property-decorator";
import Ajax from "@core/ajax";
var PULL_TIMEOUT = 60000;
var Dashboard = /** @class */ (function (_super) {
    __extends(Dashboard, _super);
    function Dashboard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.lastPull = new Date();
        return _this;
    }
    Dashboard.prototype.created = function () {
        var _this = this;
        this.widgets = {};
        // Listen for widget registrations
        this.$on('widget-registered', function (widget) { return _this.onWidgetRegister(widget); });
    };
    Dashboard.prototype.mounted = function () {
        var _this = this;
        this.lastUpdateElement = document.querySelector('#dashboardTime > time');
        document.addEventListener('visibilitychange', function () {
            _this.onVisibilityChange(!document.hidden);
        });
        // Schedule first pull
        this.schedulePullChanges();
    };
    Dashboard.prototype.schedulePullChanges = function () {
        var _this = this;
        this.lastUpdateElement.textContent = new Date().toLocaleString();
        if (this.pullTimeout) {
            clearTimeout(this.pullTimeout);
        }
        if (!document.hidden) {
            this.pullTimeout = setTimeout(function () { return _this.pullChanges(); }, PULL_TIMEOUT);
        }
    };
    Dashboard.prototype.pullChanges = function () {
        var _this = this;
        var originalSearch = location.search;
        var dbSearchParam = "_db_since=".concat(this.lastPull.toISOString());
        // Build query url
        var url = location.href;
        if (originalSearch) {
            url = location.href.replace(originalSearch, "".concat(originalSearch, "&").concat(dbSearchParam));
        }
        else {
            url = "".concat(location.href, "?").concat(dbSearchParam);
        }
        // Execute request, update widgets and schedule next
        Ajax.json(url, {}, 'get').then(function (results) {
            var timestamp = new Date(results.timestamp);
            for (var key in results.data) {
                if (key in _this.widgets) {
                    _this.widgets[key].$emit('update-data', results.data[key]);
                }
            }
            _this.lastPull = timestamp;
            _this.schedulePullChanges();
        }, function (error) {
            console.error('Dashboard pull failed', error);
            _this.schedulePullChanges();
        });
    };
    /**
     * Handle widget registration
     * @param widget
     */
    Dashboard.prototype.onWidgetRegister = function (widget) {
        this.widgets[widget.$props.id] = widget;
    };
    /**
     *
     * @param visible
     */
    Dashboard.prototype.onVisibilityChange = function (visible) {
        clearTimeout(this.pullTimeout);
        if (visible) {
            this.pullChanges();
        }
    };
    Dashboard = __decorate([
        Component({
            components: {
                TextStatsWidget: TextStatsWidget,
                StatusWidget: StatusWidget,
                TwoStatusWidget: TwoStatusWidget,
                ChartWidget: ChartWidget,
                HtmlWidget: HtmlWidget
            }
        })
    ], Dashboard);
    return Dashboard;
}(Vue));
export default Dashboard;
